// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mt-0";